import "moment/locale/ja"; // Import Japanese locale
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../redux/store";
import { getDashboard } from "../redux/Reducers/dashboardReducer";
import moment from "moment";
import { colors } from "../common/colors";
import Chart from "../components/Chart";
import UserActionTop from "../components/Phase2/UserActionTop";
import LoadingModal from "../components/LoadingModal";
import MebukuIdUpgradeBanner from "../components/MebukuIdUpgradeBanner";
import GCBackButton from "../components/GreenCity/GCBackButton";
import appServices from "../services/app-services/appServices";
import { Stack, Typography } from "@mui/material";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import IconButton from "@mui/material/IconButton";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";

export default function DashboardPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { postTypeOne } = useSelector((state: any) => state.dashboard);
  const [topOpinion, setTopOpinion] = useState<any>();
  const [topEVP, setTopEVP] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const [postsInterval, setPostsInterval] = useState<any>();
  const [postsCount, setPostsCount] = useState<any>([]);
  const [suggestions, setSuggestionsCount] = useState<any>({});

  useEffect(() => {
    // pass
  }, [postsInterval, postTypeOne, suggestions]);

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getDashboard());
    apiCall();
    // eslint-disable-next-line
  }, []);

  const apiCall = async () => {
    try {
      setLoading(true);
      const suggestionsCount = await appServices.getSuggestionsInterval();
      setSuggestionsCount(suggestionsCount);
      const topOp = await appServices.getTopOpinionPosts();
      setTopOpinion(topOp.posts);

      const topEV = await appServices.getTopEveryOnesPosts();
      setTopEVP(topEV.posts);
      const pp = await appServices.getDashboard2();
      setPostsInterval(pp);
      const pc = await appServices.getDashboard3();
      setPostsCount(pc);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 10, marginTop: 80 }}>
      <GCBackButton onClick={() => navigate(-1)} />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"center"}
        spacing={2}
      >
        <LeaderboardIcon />
        <Typography style={{}}>{T("dashboard")}</Typography>
      </Stack>
      <div
        style={{
          width: "95%",
          height: 3,
          backgroundColor: "black",
          margin: 4,
        }}
      ></div>
      <p>
        {T("dashboard_description")}
      </p>
      <LoadingModal visible={loading} />

      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          alignContent: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <p>
          <IconButton
            aria-label="fingerprint"
            style={{ backgroundColor: "#FFD8EE" }}
          >
            <PanToolOutlinedIcon style={{ color: "#000000" }} />
          </IconButton>
          {T("dashboard_suggestion")}
        </p>

        <div style={{ width: "100%", backgroundColor: "#FFD8EE" }}>
          {suggestions?.monthly?.length > 0 && (
            <Chart
              data={suggestions.monthly
                .slice(0, 6)
                .map((item: any) => ({
                  jp_name: moment(item.interval_start)
                    .locale("ja")
                    .format("MMMM"),
                  count: item.suggestion_count || 0,
                }))
                .reverse()} // Reverse the order of the data
              color={"#FB9ACD"}
            />
          )}
        </div>
        <br />
        <br />
        <div style={{ width: "100%", backgroundColor: "#FFD8EE" }}>
          <Chart
            data={[
              {
                jp_name: T("number_of_post"),
                count:
                  postsCount[0]?.post_types["1"]?.posts +
                    postsCount[1]?.post_types["1"]?.posts +
                    postsCount[2]?.post_types["1"]?.posts || 0,
              },
              {
                jp_name: T("dashboard_number_of_likes"),
                count:
                  postsCount[0]?.post_types["1"]?.post_likes +
                    postsCount[1]?.post_types["1"]?.post_likes +
                    postsCount[2]?.post_types["1"]?.post_likes || 0,
              },
              {
                jp_name: T("dashboard_number_of_comments"),
                count:
                  postsCount[0]?.post_types["1"]?.comments +
                    postsCount[1]?.post_types["1"]?.comments +
                    postsCount[2]?.post_types["1"]?.comments || 0,
              },
              {
                jp_name: T("dashboard_number_of_votes"),
                count:
                  postsCount[0]?.post_types["1"]?.votes +
                    postsCount[1]?.post_types["1"]?.votes +
                    postsCount[2]?.post_types["1"]?.votes || 0,
              },
            ]}
            color={colors.farm_yellow800}
            colors={["#B7E68E", "#FC98BE", "#87BBF2", "#FFD483"]}
          />
          <p>{T("dashboard_note_of_opinion")}</p>
        </div>
        <UserActionTop topPosts={topOpinion} bgColor={"#FFD8EE"} />
      </div>
      <br />
      <br />
      <br />
      <p>
        <IconButton
          aria-label="fingerprint"
          style={{ backgroundColor: "#B7E68E" }}
        >
          <DriveFileRenameOutlineOutlinedIcon style={{ color: "#000000" }} />
        </IconButton>
        {T("dashboard_post")}
      </p>
      <div style={{ backgroundColor: "#E8DF99" }}>
        <Chart
          data={[
            {
              jp_name: postsCount[0]?.name,
              count: postsCount[0]?.post_types["0"]?.posts || 0,
            },
            {
              jp_name: postsCount[1]?.name,
              count: postsCount[1]?.post_types["0"]?.posts || 0,
            },
            {
              jp_name: postsCount[2]?.name,
              count: postsCount[2]?.post_types["0"]?.posts || 0,
            },
          ]}
          color={"#B7E68E"}
        />
      </div>
      <br />
      <br />
      <div style={{ backgroundColor: "#E8DF99" }}>
        <Chart
          data={[
            {
              jp_name: T("number_of_post"),
              count:
                postsCount[0]?.post_types["0"]?.posts +
                  postsCount[1]?.post_types["0"]?.posts +
                  postsCount[2]?.post_types["0"]?.posts || 0,
            },
            {
              jp_name: T("dashboard_number_of_likes"),
              count: postsInterval?.monthly?.post_likes_count,
            },
            {
              jp_name: T("dashboard_number_of_comments"),
              count: postsInterval?.monthly?.comments_count,
            },
            {
              jp_name: T("dashboard_number_of_votes"),
              count: postsInterval?.monthly?.votes_count,
            },
          ]}
          color={colors.farm_yellow800}
          colors={["#B7E68E", "#FC98BE", "#87BBF2", "#FFD483"]}
        />
      </div>
      <br />
      <br />

      <UserActionTop topPosts={topEVP} bgColor={"#E8DF99"} />

      <br />
      <br />
      <MebukuIdUpgradeBanner />
    </div>
  );
}
